import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Inject, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { CustomIcons } from '@shared/models/custom-icons';
import { chunk, cloneDeep } from 'lodash';
import { DOCUMENT } from '@angular/common';
import { SmallCardData } from 'app/modules/main/models/smal-card';
import { Store } from '@ngxs/store';
import { CarouselData } from '../../models/carousel';
import { CatalogFilter } from '../../../data/modules/catalog-data/models/catalog.service';
import { ChangeCatalogFilter } from '../../../data/modules/catalog-data/store/catalog-table.actions';

@Component({
  selector: 'app-small-card-block',
  templateUrl: './small-card-block.component.html',
  styleUrls: ['./small-card-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmallCardBlockComponent {
  private _isFloating = false;
  private _smallCardData: SmallCardData[];
  @Input() public clickable = false;
  @Input() public textColorClass = 'primary-color-60';
  @Input() public criteria: CatalogFilter | null;
  @Input() public criteriaLink: string;
  @Input() public hasShowDownloads: boolean;
  @Input() public grayHideScroll = false;

  public get isFloating(): boolean {
    return this._isFloating;
  }

  @Input()
  public set isFloating(isFloat: boolean | null) {
    this._isFloating = !!isFloat;
    this.setCardChunk();
  }

  public get smallCardAllData(): SmallCardData[] {
    return this._smallCardData;
  }

  @Input() public set smallCardAllData(value: SmallCardData[]) {
    if (value) {
      this._smallCardData = cloneDeep(value);
      this.setCardChunk();
    }
  }

  @Input()
  public smallCardData: CarouselData = {
    title: 'MAIN.AUTUMN_DATASET_RESIDENTS',
    icon: CustomIcons.EmptyStar,
    data: null
  };

  @Output() public readonly cardClick = new EventEmitter<void>();

  public breakPointObserve$ = this.breakpointObserver
    .observe(['(max-width: 1300px)', '(max-width: 948px)', '(max-width: 1920px)', '(max-width: 1780px)'])
    .pipe(
      map((state: BreakpointState) => {
        let result = 4;

        if (state.breakpoints['(max-width: 1920px)']) {
          result = this.isFloating ? 6 : 4;
        }

        if (state.breakpoints['(max-width: 1780px)']) {
          result = 4;
        }

        if (state.breakpoints['(max-width: 1300px)']) {
          result = 3;
        }

        if (state.breakpoints['(max-width: 948px)']) {
          result = 2;
        }

        if (this.smallCardData && this.smallCardAllData) {
          this.smallCardData.data = chunk(this.smallCardAllData, result);
          this.cdr.detectChanges();
        }

        return result;
      })
    );

  constructor(
    private store: Store,
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  private setCardChunk() {
    const screenWidth = this.document.defaultView?.innerWidth;
    let chunkSize;

    if (screenWidth && screenWidth > 1780) {
      chunkSize = 4; /* this._isFloating ? 6 : */
    }

    if (screenWidth && screenWidth < 1780 && screenWidth > 1300) {
      chunkSize = 4;
    }

    if (screenWidth && screenWidth <= 1300) {
      chunkSize = 3;
    }

    if (this.smallCardData && this.smallCardAllData) {
      this.smallCardData.data = chunk(this.smallCardAllData, chunkSize);
      this.smallCardData = cloneDeep(this.smallCardData);
    }
  }

  public setFilter(): void {
    if (this.criteria) {
      this.store.dispatch(new ChangeCatalogFilter(this.criteria, false, true));
    }
  }
}
